<div class="fixed-grid mb-4">
  <div class="grid is-gap-2">
    <div class="cell">
      @if (tenantSettings) {
        <app-action-box
          class="mb-4 is-flex is-fullheight"
          header="overview.basicInfo.info.title"
          subHeader="overview.basicInfo.info.subtitle"
          iconSrc="/assets/icons/icon-info.svg"
          iconClass="p-4"
          hideCtaButton
          isNotClickable
        >
          <div
            class="p-4 is-flex is-align-items-center is-flex-direction-column"
          >
            <p class="title is-size-5" translate>
              overview.basicInfo.basicInfo
            </p>

            @if (showFusionSection) {
              <figure class="image logo">
                <img [src]="logoUrl()" />
              </figure>
              <p class="has-text-grey">Ihr Logo</p>
            }

            <div class="is-flex is-justify-content-space-between">
              <div class="is-flex is-flex-direction-column">
                <span translate>overview.basicInfo.blz</span>
                @if (tenantSettings.bic) {
                  <span translate>overview.basicInfo.bic</span>
                }
              </div>
              <div class="is-flex is-flex-direction-column pl-4">
                <strong>{{ tenantSettings.blz | blz }}</strong>
                @if (tenantSettings.bic) {
                  <strong>{{ tenantSettings.bic }}</strong>
                }
              </div>
            </div>
          </div>
        </app-action-box>
      }
    </div>
    <div class="cell is-flex is-flex-direction-column">
      <app-action-box
        class="is-flex is-flex-grow-1"
        header="overview.actions.logo.title"
        subHeader="overview.actions.logo.subtitle"
        icon="Image File Upload"
        (click)="openLogoModal()"
      >
        @if (!showFusionSection) {
          <div
            class="is-flex is-align-items-center is-flex-direction-column mt-3"
          >
            <figure class="image logo">
              <img [src]="logoUrl()" />
            </figure>
          </div>
        }
      </app-action-box>

      @if (showFusionSection) {
        <app-action-box
          class="mt-4 is-flex is-flex-grow-1"
          header="overview.actions.fusion.title"
          subHeader="overview.actions.fusion.subtitle"
          icon="Database Connect"
          (click)="openFusionModal()"
        ></app-action-box>
      }
    </div>
  </div>
</div>

<div class="fixed-grid has-1-cols">
  <div class="grid">
    <div class="cell">
      <app-action-box
        class="mb-4 is-flex is-fullheight"
        header="adminUsers.users.title"
        subHeader="adminUsers.users.subtitle"
        icon="Single Neutral Actions Setting"
        isNotClickable
        hideCtaButton
      >
        <app-admin-users></app-admin-users>
      </app-action-box>
    </div>
  </div>
</div>
